import { Menu } from '../models/menu.interfaces';
import * as Sections from './sections';

export const MenuMocks: Menu = {
  sections: [
    Sections.SkyMilesSectionMocks,
    Sections.TripsSectionMocks,
    Sections.ProfileSectionMocks,
    Sections.ReceiptsSectionMocks
  ],
  disabled: false,
  loaded: true
};

export const MenuBusinessTravelerMocks: Menu = {
  sections: [
    Sections.SkyMilesBusinessTravelerSectionMocks,
    Sections.TripsSectionMocks,
    Sections.ProfileSectionMocks,
    Sections.ReceiptsSectionMocks
  ],
  disabled: false,
  loaded: true
};

export const MenuEmptyMocks: Menu = {
  sections: [],
  disabled: false,
  loaded: false
};
